import { createCmsProviderAdapter } from '@eneco/cms-sanity';
import { createSitecoreAdapter } from '@eneco/cms-sitecore';
import env from '@eneco/common/env';
// Deep import, NOT the `@eneco/next/server` barrel, which drags server-only modules into the
// browser bundle (see `containers/nl/eneco/mkb/cms-config.ts`).
import { getContainerBasePath } from '@eneco/next/server/utils/getContainerBasePath';

import { sanitySite } from './config';

let instance: ReturnType<typeof createSitecoreAdapter> | undefined;

export const getCmsAdapter = () => {
  if (!instance) {
    const layoutServiceUrl = `${env('SITECORE_API_HOST')}${env('SITECORE_LAYOUT_SERVICE_ROUTE')}`;
    const apiKey = env('SITECORE_API_KEY');
    instance = createSitecoreAdapter({ layoutServiceUrl, apiKey });
  }
  return instance;
};

// No `allowSharedEnvironment`: the `?_cms=` override resolves on development, test and local only,
// and stays closed on acceptance and production (see `is-sanity-enabled.ts`).
export const { getSanityAdapter, selectCmsAdapter } = createCmsProviderAdapter(getCmsAdapter, {
  site: sanitySite,
  basePath: getContainerBasePath(),
});
